import { FC, useEffect, useState } from "react";
import { DCIcon } from "../assets/icons";
import { useSocketStore, useThemeStore } from "../stores";

const SockStatusIndicator: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const isOpen = useSocketStore((s) => s.isOpen);

  const [opacity, setOpacity] = useState<number>(1);

  useEffect(() => {
    let interval = setInterval(() => {
      setOpacity((prev) => (prev ? 0 : 1));
    }, 500);
    return () => {
      clearInterval(interval);
    };
  }, []);

  if (isOpen) return <></>;
  return (
    <div style={{ ...styles.container, opacity }} className="transition">
      <DCIcon color={theme.alert} width={100} height={100} />
    </div>
  );
};

export default SockStatusIndicator;

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 9999999,
  },
};
